// seoConfig.js
export const seoConfig = {
  "/": {
    title: "TalkyToon | Fun Learning & Animated Stories for Kids",
    description:
      "TalkyToon offers fun animated stories, songs, games, and learning activities for kids. A safe, joyful platform for early learning and creativity.",
    keywords:
      "TalkyToon, kids learning, animated stories, kids education, bedtime stories, kids games",
  },

  // ===== LEARN =====
  "/alphabet": {
    title: "Alphabet A–Z for Kids | TalkyToon",
    description:
      "Learn Alphabet A–Z with fun animations, sounds, and visuals. Help kids recognize letters and build early literacy skills.",
    keywords: "alphabet for kids, abc learning, kids phonics, TalkyToon alphabet",
  },
  "/numbers": {
    title: "Numbers & Math for Kids | TalkyToon",
    description:
      "Fun number learning, counting games, and simple math activities designed for young kids.",
    keywords: "numbers for kids, counting, math for kids, TalkyToon numbers",
  },
  "/phonics": {
    title: "Reading & Phonics for Kids | TalkyToon",
    description:
      "Build reading confidence with phonics sounds, word recognition, and interactive learning.",
    keywords: "phonics for kids, reading skills, kids learning to read",
  },
  "/science": {
    title: "Science Basics for Kids | TalkyToon",
    description:
      "Explore basic science concepts through simple animations and fun explanations for kids.",
    keywords: "science for kids, kids experiments, basic science learning",
  },
  "/lifeskills": {
    title: "Life Skills for Kids | TalkyToon",
    description:
      "Teach kids kindness, sharing, emotions, and daily life skills through engaging stories.",
    keywords: "life skills for kids, moral learning, kids values",
  },

  // ===== PLAY =====
  "/playgames": {
    title: "Fun Games for Kids | TalkyToon",
    description:
      "Play safe, fun, and educational games designed for young kids.",
    keywords: "kids games, educational games, fun games for children",
  },
  "/puzzlecorner": {
    title: "Puzzle Corner for Kids | TalkyToon",
    description:
      "Improve problem-solving skills with colorful and fun puzzles for kids.",
    keywords: "kids puzzles, brain games for kids",
  },
  "/createdraw": {
    title: "Create & Draw for Kids | TalkyToon",
    description:
      "Let kids draw, color, and create freely with fun digital tools.",
    keywords: "drawing for kids, kids creativity, coloring games",
  },
  "/animals": {
    title: "Animals & Sounds for Kids | TalkyToon",
    description:
      "Learn animal names and sounds through cute animations and fun activities.",
    keywords: "animals for kids, animal sounds, kids learning animals",
  },
  "/musicdance": {
    title: "Music & Dance for Kids | TalkyToon",
    description:
      "Enjoy fun kids songs, music, and dance activities that boost creativity.",
    keywords: "kids songs, music for kids, dance for children",
  },

  // ===== STORIES =====
  "/storytime": {
    title: "Story Time for Kids | TalkyToon",
    description:
      "Enjoy short, fun, and engaging stories perfect for kids and bedtime.",
    keywords: "kids stories, bedtime stories, short stories for kids",
  },
  "/moralstories": {
    title: "Moral Stories for Kids | TalkyToon",
    description:
      "Heartwarming moral stories that teach values, kindness, and good habits.",
    keywords: "moral stories for kids, kids values, learning stories",
  },

  // ===== PARENTS =====
  "/parentcontrol": {
    title: "Parent Dashboard | TalkyToon",
    description:
      "Manage your child’s learning experience with parental controls and progress tracking.",
    keywords: "parent dashboard, parental control, kids learning management",
  },

  // ===== SHOP =====
  "/shop": {
    title: "Shop Kids Products | TalkyToon",
    description:
      "Buy fun learning toys, books, and merchandise designed for kids.",
    keywords: "kids shop, educational toys, kids merchandise",
  },

  // ===== EVENTS =====
  "/workshops": {
    title: "Kids Workshops & Events | TalkyToon",
    description:
      "Join creative workshops and learning events specially designed for kids.",
    keywords: "kids workshops, learning events for children",
  },
};
